/**
 * MySimShop — Custom JS
 * Scroll reveal + micro-interactions
 */

(function () {
  'use strict';

  /* ----------------------------------------------------------------
     Scroll Reveal — IntersectionObserver (GPU-only transitions)
     Activates .mss-reveal elements when they enter the viewport.
  ---------------------------------------------------------------- */
  function initScrollReveal() {
    const elements = document.querySelectorAll('.mss-reveal');
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ----------------------------------------------------------------
     Staggered grid reveal — tilføjer delay-klasser til grid-items
  ---------------------------------------------------------------- */
  function initGridStagger() {
    const grids = document.querySelectorAll('.mss-stagger-grid');
    grids.forEach(function (grid) {
      const items = grid.querySelectorAll('.mss-reveal');
      items.forEach(function (item, i) {
        const delay = Math.min(i, 4);
        if (delay > 0) {
          item.classList.add('mss-reveal-d' + delay);
        }
      });
    });
  }

  /* ----------------------------------------------------------------
     Trust strip icon bounce — aktiveres ved scroll-in
  ---------------------------------------------------------------- */
  function initTrustAnimations() {
    const trustItems = document.querySelectorAll('.mss-trust-item');
    if (!trustItems.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          trustItems.forEach(function (item, i) {
            setTimeout(function () {
              item.classList.add('mss-trust-bounce');
            }, i * 80);
          });
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (trustItems[0]) observer.observe(trustItems[0].closest('.mss-trust-strip') || trustItems[0]);
  }

  /* ----------------------------------------------------------------
     Rating Count-Up — animerer rating-tal ved scroll-in
     Bruger data-count-up + data-count-start attributter.
  ---------------------------------------------------------------- */
  function initRatingCountUp() {
    var counters = document.querySelectorAll('[data-count-up]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var target = parseFloat(el.getAttribute('data-count-up'));
          var start = parseFloat(el.getAttribute('data-count-start') || (target - 0.9).toFixed(1));
          var duration = 700;
          var startTime = null;

          function tick(currentTime) {
            if (!startTime) startTime = currentTime;
            var elapsed = currentTime - startTime;
            var progress = Math.min(elapsed / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = (start + (target - start) * eased).toFixed(1);
            if (progress < 1) requestAnimationFrame(tick);
          }

          requestAnimationFrame(tick);
          observer.unobserve(el);
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach(function (el) { observer.observe(el); });
  }

  /* ----------------------------------------------------------------
     Init
  ---------------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollReveal();
      initGridStagger();
      initTrustAnimations();
      initRatingCountUp();
    });
  } else {
    initScrollReveal();
    initGridStagger();
    initTrustAnimations();
    initRatingCountUp();
  }
})();
